class NumberInput {
	constructor( args = {} ) {
		this.args = {
			debug: false,
			input: null,
			root: null,
			labelNbSel: '.nb',
			minFallback: 1,
			...args
		};

		this.input = this.args.input;
		this.root = this.args.root || ( this.input ? this.input.closest( '.form-element-count' ) : null );

		this.decreaseButton = null;
		this.increaseButton = null;
		this.labelNbEl = null;

		this.init();
	}

	init() {
		if( ! this.input ) {
			if( this.args.debug ) {
				console.warn( 'NumberInput: missing input element.' );
			}
			return;
		}

		this.resolveElements();
		this.hydrateInitialValue();
		this.bindEvents();
		this.render();

		this.input._numberInput = this;

		
	}

	resolveElements() {
		const scope = this.root || document;

		this.decreaseButton = scope.querySelector( '.input-number-decrease' );
		this.increaseButton = scope.querySelector( '.input-number-increase' );
		this.labelNbEl = scope.querySelector( this.args.labelNbSel );
	}

	getMin() {
		const minAttr = this.input.getAttribute( 'min' );
		const min = Number( minAttr );

		return Number.isFinite( min ) ? min : this.args.minFallback;
	}

	getMax() {
		const maxAttr = this.input.getAttribute( 'max' );
		const max = Number( maxAttr );

		return Number.isFinite( max ) ? max : null;
	}

	getValue() {
		const value = Number( this.input.value );
		return Number.isFinite( value ) ? value : this.getMin();
	}

	setValue( value ) {
		const min = this.getMin();
		const max = this.getMax();

		let next = Number( value );

		if( ! Number.isFinite( next ) ) {
			next = min;
		}

		if( next < min ) {
			next = min;
		}

		if( max !== null && next > max ) {
			next = max;
		}

		this.input.value = String( next );

		this.input.dispatchEvent( new Event( 'input', { bubbles: true } ) );
		this.input.dispatchEvent( new Event( 'change', { bubbles: true } ) );
	}

	hydrateInitialValue() {
		this.setValue( this.getValue() );
	}

	change( delta ) {
		this.setValue( this.getValue() + delta );
		this.render();
	}

	render() {
		const value = this.getValue();
		const min = this.getMin();
		const max = this.getMax();

		if( this.labelNbEl ) {
			this.labelNbEl.textContent = String( value );
		}

		if( this.decreaseButton ) {
			this.decreaseButton.disabled = ( value <= min );
		}

		if( this.increaseButton ) {
			this.increaseButton.disabled = ( max !== null && value >= max );
		}
	}

	bindEvents() {
		if( this.decreaseButton ) {
			this.decreaseButton.addEventListener( 'click', ( event ) => {
				event.preventDefault();
				this.change( -1 );
			} );
		}

		if( this.increaseButton ) {
			this.increaseButton.addEventListener( 'click', ( event ) => {
				event.preventDefault();
				this.change( 1 );
			} );
		}

		this.input.addEventListener( 'input', () => this.render() );
		this.input.addEventListener( 'change', () => this.render() );
	}

	static initAll( selector = '.input-number', args = {} ) {
		document.querySelectorAll( selector ).forEach( ( input ) => {
			new NumberInput( {
				...args,
				input
			} );
		} );
	}
}

export default NumberInput;